import { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

import { IconButton } from '@/components/button';

import { useExplorationCellContext } from '../exploration-cell-context';

import * as style from './collapsible-cell.module.scss';

interface CollapsibleContainerProps {
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
  children: React.ReactNode;
}

export const CollapsibleContainer = forwardRef(function CollapsibleContainer(
  props: CollapsibleContainerProps,
  ref?: ForwardedRef<HTMLDivElement | null>,
) {
  const { isCollapsed } = useExplorationCellContext();

  return (
    <div
      className={classNames(props.className, style.collapsibleContainer, {
        [style.collapsed]: isCollapsed,
      })}
      data-hide-from-print={isCollapsed || undefined}
      onClick={props.onClick}
      ref={ref}>
      {props.children}
    </div>
  );
});

export const CollapseButton = () => {
  const { isCollapsed, toggleCollapsed } = useExplorationCellContext();

  const handleCollapseClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    toggleCollapsed();
  };

  return (
    <IconButton
      icon="ChevronUp"
      title={isCollapsed ? 'Expand' : 'Collapse'}
      className={style.collapseButton}
      onClick={handleCollapseClick}
    />
  );
};

type CollapsibleContentProps = { children: React.ReactNode; isDragHovered?: boolean };

export const CollapsibleContent = ({
  children,
  isDragHovered = false,
}: CollapsibleContentProps) => {
  return (
    <div
      className={classNames(style.collapsibleContent, {
        [style.dragHandleHovered]: isDragHovered,
      })}>
      <div className={style.overflowGuard}>{children}</div>
    </div>
  );
};
